import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {ReplaySubject, Subject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ListResponse} from "../interface/response/list-response";
import {first, take} from "rxjs/operators";
import {DobryAgentPartner} from "../interface/dobry-agent-partner";

@Injectable({
  providedIn: 'root'
})
export class DaPartnerService {
  private readonly partnerListSubject:  ReplaySubject<CountedAndPaginated<DobryAgentPartner>> =
    new ReplaySubject<CountedAndPaginated<DobryAgentPartner>>(1);
  private readonly partnerNotCountedListSubject: ReplaySubject<ListResponse<DobryAgentPartner>> =
    new ReplaySubject<ListResponse<DobryAgentPartner>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  )
  {
  }

  public loadList(
    page: number,
    pageSize: number,
    filters: object,
    subject?: Subject<CountedAndPaginated<DobryAgentPartner>>,
    sort?: {
      sortBy?: string;
      sortOrder?: string;
    }
  ): void {
    this.httpClient.get(`/rest/crm/dobry-agent/partner?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}
    &sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<DobryAgentPartner>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.partnerListSubject.next(result);
        }
      });
  }

  public loadNotCountedList(
    page: number,
    pageSize: number,
    filters: object,
    observable?: ReplaySubject<ListResponse<DobryAgentPartner>>
  ): void {
    this.httpClient
      .get(`/rest/crm/dobry-agent/partner?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        take(1)
      ).subscribe((result: ListResponse<DobryAgentPartner>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.partnerNotCountedListSubject.next(result);
        }
    });
  }
}
